// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1Xg-B","range":"MonthRangeSwitch_range__1MQFR","disabled":"MonthRangeSwitch_disabled__KZFOd"};